import { render, staticRenderFns } from "./GenerationHistoryPromptPopover.vue?vue&type=template&id=87afd246"
import script from "./GenerationHistoryPromptPopover.vue?vue&type=script&lang=js"
export * from "./GenerationHistoryPromptPopover.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports